import type { RouteRecordRaw } from 'vue-router';

export const departmentsRoute: RouteRecordRaw = {
  path: '/departments',
  name: 'Departments',
  component: () => import('./pages/DepartmentsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:departments:list'),
  },
};
